export default {"src":"/_next/static/media/ionic.f459d036.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};